module.exports = __webpack_public_path__ + "assets/img/platform-google-play-86e8cfb1.png";